import { t } from '@lingui/core/macro';

import { Legend, LegendItem } from '@/components/Legend';
import { COLOR_GREEN_100, COLOR_RED_300 } from '@/styles/palette';

const FitScoreLegend = () => {
  return (
    <Legend noToggleVisibility>
      <LegendItem value="highest" color={COLOR_GREEN_100} name={t`Highest Performer`} />
      <LegendItem value="lowest" color={COLOR_RED_300} name={t`Lowest Performer`} />
    </Legend>
  );
};

export default FitScoreLegend;
